import React, { Component ,useState, useEffect } from 'react';

import {
    Route,
  } from 'react-router-dom';

import Login from '../pages/loginpages/login';


  function adminRoute({ children, isAuth, ...rest  }) {
    return (
      <Route
        {...rest}
        render={
          ({ location }) => (
            (isAuth) ? (
              children
            ) : (
             <Login/>
             
            )
            )
        }
      />
    );
  }
  
  export default adminRoute;